import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';
import { CartService } from 'src/app/services/cart.service';
import { DmCardEditModal } from '../modal/dm-card-edit-modal/dm-card-edit-modal.component';

@Component({
  selector: 'dm-cart-box-edit',
  templateUrl: './dm-card-box-edit.component.html',
  styleUrls: ['./dm-card-box-edit.component.scss']
})
export class DmCartBoxEditComponent implements OnInit {

  @Input("servico") servico:any                   = null;  
  @Input("configuracaoLoja") configuracaoLoja:any = null;
   public total              = 0;

  constructor(
    public app: AppService,  
    public dialog: MatDialog,
    public cart: CartService
  ){}

  /**
   * 
   * Open modal
   * 
   */
  open(){

    this.dialog.open(DmCardEditModal,{
      width: "800px",
      data: {
        servico: this.servico,
        configuracaoLoja: this.configuracaoLoja,
        cartService: this.cart
      }      
    });

  }
  /**
   * 
   * set total
   * 
   */
  setTotal(){

    this.total = (parseFloat(this.servico.valor_adt)*this.servico.qtd_adt)+(parseFloat(this.servico.valor_snr)*this.servico.qtd_snr)+(parseFloat(this.servico.valor_chd)*this.servico.qtd_chd)+(parseFloat(this.servico.valor_servico));

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{
    this.setTotal();
  }

}
